import apiClient from '../../../core/Api';
import { Relevance } from '../models/topic-tag-scoring';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const listRelevances = (): Promise<Relevance[]> => {
  return apiClient.get(`${API_BASE_URL}/relevances`).then((response) => response.data.relevances);
};

const listCuratedInclusions = (): Promise<Relevance[]> => {
  return apiClient.get(`${API_BASE_URL}/curated-inclusions`).then((response) => response.data.curatedInclusions);
};

export { listRelevances, listCuratedInclusions };
